module.exports = __webpack_public_path__ + "img/traffic-light-stop.ce975dc4.svg";